import { steps } from "@/mocks/home";

export default function ProcessSection() {
  return (
    <section id="process" className="bg-primary-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs tracking-[0.25em] uppercase text-accent-300 mb-3">保密机制</p>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50">
            一条信息从提交到处理的全过程
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
            每个环节都有明确的处理规则，接触范围按需授权，尽量让你说出的内容无法被回溯到具体的人。
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((item) => (
            <li
              key={item.step}
              className="relative bg-primary-900/70 border border-primary-800 rounded-lg p-6 flex flex-col"
            >
              <span className="font-heading text-4xl font-bold text-primary-700 mb-4">{item.step}</span>
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 mb-4">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading font-semibold text-base text-background-50 mb-3">{item.title}</h3>
              <p className="text-sm leading-relaxed text-background-200">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}